import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {Edit, Schedule as ScheduleIcon} from '@material-ui/icons';
import {purple} from '@material-ui/core/colors';

function UserProperties(props) {
  const {selectedUser} = props;

  if (!!selectedUser && Object.keys(selectedUser).length > 0) {
    return (
      <Card>
        <CardHeader title={selectedUser.fullName} subheader="Properties" />
        <Divider />
        <CardContent style={{overflow: 'auto', whiteSpace: 'nowrap'}}>
          <List>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Created Date"
                secondary={new Date(selectedUser.createdDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <ScheduleIcon />
              </ListItemIcon>
              <ListItemText
                primary="Last Modified Date"
                secondary={new Date(selectedUser.modifiedDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
          </List>
        </CardContent>

        <CardActions>
          <Button
            href={`/#/Users/${selectedUser.id}/update`}
            startIcon={<Edit />}
            variant="outlined"
            style={{color: purple[500], borderColor: purple[500]}}
          >
            Edit User
          </Button>
        </CardActions>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader title="User Properties" subheader="No User Selected" />
    </Card>
  );
}

UserProperties.propTypes = {
  selectedUser: PropTypes.object,
};

UserProperties.defaultProps = {
  selectedUser: null,
};

export default UserProperties;
